import CustomersApi from "@/api/CustomersApi"
import AgreementsApi from "@/api/AgreementsApi";
import ShopsApi from "@/api/ShopsApi";

export default async function (customerId) {
  const operations = await CustomersApi.findOperationsBy(customerId.customerId)
  const shops = await ShopsApi.all()

  let newOperations = []
  for (let index = 0; index < operations.length; index++) {
    let operation = operations[index]
    operation['shopName'] = shops.find(shop => shop.code === operation.shopCode)?.name ?? "NEGOZIO NON TROVATO"
    const agreements = await AgreementsApi.findBy(operation.barcode, operation.operationDateTime)
    if (agreements.length > 0) {
      operation['agreementId'] = agreements[0]
    } else {
      operation['agreementId'] = 'none'
    }

    newOperations.push(operation)
  }

  return newOperations
}
